import {useEffect, useState} from 'react'
import {BooksitoutServer} from '../../../../config/BooksitoutServer'
import LanguageReadingSpeedResponse from '../responses/LanguageReadingSpeedResponse'

const useLanguageReadingSpeed = () => {
	const [data, setData] = useState<LanguageReadingSpeedResponse | null>(null)
	const [isLoading, setIsLoading] = useState<boolean>(true)

	useEffect(() => {
		BooksitoutServer
			.get(`/v1/statistics/languages/reading-speed`)
			.then(res => setData(res.data))
			.catch(() => setData(null))
			.finally(() => setIsLoading(false))
	}, [])

	return [data, isLoading] as const
}

export default useLanguageReadingSpeed
